// extracted by mini-css-extract-plugin
export default {"icon":"NewImplantBadge_icon__sbXAv"};